import { render } from "./ModuleInscriptionList.vue?vue&type=template&id=d9ccb01a&scoped=true"
import script from "./ModuleInscriptionList.vue?vue&type=script&lang=js"
export * from "./ModuleInscriptionList.vue?vue&type=script&lang=js"

import "./ModuleInscriptionList.vue?vue&type=style&index=0&id=d9ccb01a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ccb01a"]])

export default __exports__